module.exports = __webpack_public_path__ + "static/media/9.a7372834.png";